import { usePresenter } from "../../deck/context";
import { fmt, sectionOf, total, totalBudgetMs } from "../../rehearse/clock";

/** Rehearsal only: this section's time against its budget, and the whole talk's. Click or T to pause. */
export function RehearsalTimer() {
  const { model, clock, position } = usePresenter();
  const sectionId = sectionOf(model.slides[position.slideIndex]);
  const sec = model.sections.get(sectionId);
  const spent = clock.times[sectionId] ?? 0;
  const budget = sec ? sec.section.minutes * 60_000 : 0;
  const over = sec !== undefined && spent > budget;
  return (
    <button
      type="button"
      className="timer"
      data-running={clock.running}
      onClick={clock.toggle}
      aria-keyshortcuts="T"
      aria-label={clock.running ? "Pause the rehearsal timer" : "Start the rehearsal timer"}
      data-testid="timer"
    >
      {!clock.started ? (
        <span>Timer starts on your first move · T</span>
      ) : (
        <>
          {sec && (
            <span className="timer-part" data-over={over}>
              {String(sec.number).padStart(2, "0")} · {fmt(spent)} / {sec.section.minutes}:00
            </span>
          )}
          <span className="timer-part">
            Total {fmt(total(clock.times))} / {fmt(totalBudgetMs(model.deck))}
          </span>
          {!clock.running && <span className="timer-part timer-paused">Paused</span>}
        </>
      )}
    </button>
  );
}
